import { styled, Chip } from "@mui/material";

export const TpChip = styled(({isSelected, ...props}) => (
  <Chip size="small" variant={isSelected ? 'filled' : 'outlined'} {...props} />
))(({ theme }) => ({
  '&.MuiChip-outlined': {
    textTransform: 'none',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: theme.palette.divider,

    '&:hover': {
      backgroundColor: theme.palette.primary[400],
      color: theme.palette.primary.contrastText,
    },
  },
  '&.MuiChip-filled': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.main,
    
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  // Style the delete icon for both filled and outlined variants
  '& .MuiChip-deleteIcon': {
    fill: theme.palette.primary[300],
    color: theme.palette.primary.dark,
    border: 'none',
    transition: 'background-color 0.2s',

    // Optional: style on hover
    '&:hover': {
      fill: theme.palette.error[300],
      color: theme.palette.error[900],
    },
  },
}))
